import { Box, Container, Stack, Typography } from "@mui/material";
import NextImage from "next/image";
import { Logo } from "../../../fe-ui/atoms/Logo";

import { useTranslation } from "../../../fe-ui/hooks/use-translation";
import { ReactNode } from "react";

export function LandingContainerBanner({
  src,
  children,
  isDark,
}: {
  src: string;
  children?: ReactNode;
  isDark?: boolean;
}) {
  const t = useTranslation();

  return (
    <Container maxWidth="lg" sx={{ textAlign: "center" }}>
      <Box
        sx={{
          position: "relative",
          height: {
            lg: 500,
            md: 400,
            sm: 300,
            xs: 300,
          },
        }}
      >
        <Box
          sx={{
            position: "relative",
            overflow: "hidden",
            borderRadius: 2,
            height: "100%",
          }}
        >
          <NextImage draggable={false} layout="fill" objectFit="cover" alt="" src={src} />

          <Stack
            direction={{
              xs: "column",
              sm: "column",
              md: "row",
              lg: "row",
            }}
            alignItems={{
              xs: "flex-start",
              sm: "flex-start",
              md: "center",
              lg: "center",
            }}
            textAlign={"left"}
            spacing={2}
            sx={{
              position: "absolute",
              top: 52,
              left: 44,
            }}
          >
            <Logo isDark={isDark} width={180} />
            <Typography
              color={isDark ? "text.primary" : "white"}
              variant="bodySm"
              textAlign={"left"}
              sx={{ maxWidth: 300 }}
            >
              {t("apply_landing_logo_slogan")}
            </Typography>
          </Stack>
        </Box>
        {children}
      </Box>
    </Container>
  );
}
